module.exports = __webpack_public_path__ + "assets/img/logo1.1004c595.svg";